import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=3685d0ec&scoped=true"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"
import style0 from "./Stage.vue?vue&type=style&index=0&id=3685d0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3685d0ec",
  null
  
)

export default component.exports